// profile/ProfileTabs.jsx
import React, { useMemo } from 'react';
import styles from './styles/ProfileTabs.module.css';
import { TAB_LABEL, TABS_BY_ROLE } from './tabs';

const ProfileTabs = ({ userRole, isOwner = false, activeTab, setActiveTab }) => {
  const tabs = useMemo(() => {
    return TABS_BY_ROLE[userRole] ? [...TABS_BY_ROLE[userRole]] : [];
  }, [userRole]);

  return (
    <div className={styles.profileTabs}>
      {tabs.map((tabKey) => (
        <button
          key={tabKey}
          type="button"
          className={`${styles.tab} ${activeTab === tabKey ? styles.active : ''}`}
          onClick={() => setActiveTab(tabKey)}
        >
          {/* タブごとにアイコンを表示 */}
          {tabKey === 'upcoming' && (
            <img src="/icons/calender_mono.svg" alt="今後のイベント" className={styles.tabIcon} />
          )}
          {tabKey === 'purchased' && (
            <img src="/icons/calender_mono.svg" alt="購入済みイベント" className={styles.tabIcon} />
          )}
          {tabKey === 'past' && (
            <img src="/icons/clock.svg" alt="過去のイベント" className={styles.tabIcon} />
          )}
          {tabKey === 'gallery' && (
            <img src="/icons/image_mono.svg" alt="ギャラリー" className={styles.tabIcon} />
          )}
          {TAB_LABEL[tabKey]}
        </button>
      ))}
    </div>
  );
};

export default ProfileTabs;
